export default __webpack_public_path__ + "static/media/Poster.37fea90d.png";